import { render, staticRenderFns } from "./AudioAnnotationArea.vue?vue&type=template&id=0429f70a&scoped=true&"
import script from "./AudioAnnotationArea.vue?vue&type=script&lang=js&"
export * from "./AudioAnnotationArea.vue?vue&type=script&lang=js&"
import style0 from "./AudioAnnotationArea.vue?vue&type=style&index=0&id=0429f70a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0429f70a",
  null
  
)

export default component.exports